import axios from 'axios';

const currentHost = window.location.host.replace('3002', '8081');
    
export const API_URL = `${window.location.protocol}//${currentHost}`;//'http://testdomain.com:8082';

// Configure axios to include credentials (cookies)
axios.defaults.withCredentials = true;

export const loginUser = async (username, password) => {
  const formData = new FormData();
  formData.append('username', username);
  formData.append('password', password);
  
  try {
    const response = await axios.post(`${API_URL}/app/login`, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export async function connectAndSendMessage(identifier, message, onComplete, onStreamUpdate, token, showErrorMessage, _postData, url,wasNewChat,getChatTitle,connectionId,updateThinkingContent,updateLoadingStateToFalseAndShowThinkingText,hasReceivedThinkingRef) {
  // const baseUrl = process.env.REACT_APP_API_GATEWAY_URL || "http://testdomain.com:8081";
  const sseUrl = `${API_URL}/app/sse/chat/${identifier}`;
  const postUrl = url;

  let fullResponse = "";

  try {
    // Create SSE connection
    const eventSource = new EventSource(sseUrl, { withCredentials: true });

    return new Promise((resolve, reject) => {
      let responseData =  null;
      eventSource.onopen = async () => {
        // Once connected, send message
        eventSource.addEventListener("THINKING", (event) => {
          const parsed = JSON.parse(event.data);
          updateThinkingContent(parsed.content);
        });
        try {
          const res = await fetch(postUrl, {
            method: "POST",
            headers: {
              'X-CSRF-TOKEN': token
             },
            credentials: "include",
            body: _postData,
          });

          responseData = await res.json();
          if(responseData && responseData.responseType === "STREAMING"){
            // Handle streamed response
            // updateLoadingStateToFalseAndShowThinkingText();
            // Only show "thinking..." fallback UI if the server did not send any THINKING
            setTimeout(() => {
              if (!hasReceivedThinkingRef.current) {
                updateLoadingStateToFalseAndShowThinkingText();
              }
            }, 150);
            eventSource.addEventListener("TOKEN", (event) => {
              const parsed = JSON.parse(event.data);
              fullResponse += parsed.content;
              if (onStreamUpdate) {
                // Always call inside React's scheduler
                Promise.resolve().then(() => onStreamUpdate(parsed.content,connectionId));
              }
            });

            eventSource.addEventListener("THINKING", (event) => {
              const parsed = JSON.parse(event.data);
              updateThinkingContent(parsed.content,connectionId);
            });
      
            eventSource.addEventListener("COMPLETION", (event) => {
              if (onComplete) onComplete(fullResponse.trim(),responseData.chatMessageIdentifier,connectionId);
              eventSource.close();
              if(wasNewChat){
                getChatTitle(connectionId);
              }
              resolve(fullResponse.trim());
            });
      
            eventSource.onerror = (error) => {
              console.error("❌ SSE connection error:", error);
              eventSource.close();
              var isStreaming = error.response?.responseType === "STREAMING" ? true : false;
              showErrorMessage(isStreaming);
              reject(error);
            };
          }else{
            onComplete(responseData.chatMessage,responseData.chatMessageIdentifier);
            eventSource.close();
            if(wasNewChat){
              getChatTitle(connectionId);
            }
            resolve(responseData.chatMessage);
          }
        } catch (err) {
          console.error("❌ Error in POST:", err);
          reject(err);
        }
      };

    });
  } catch (error) {
    console.error("❌ Error in connectAndSendMessage:", error);
    var isStreaming = error.response?.responseType === "STREAMING" ? true : false;
    showErrorMessage(isStreaming);
    throw error;
  }
}
